import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VExpansionPanelContent,_vm._g(_vm._b({staticClass:"w-expansion-panel-content"},'v-expansion-panel-content',_vm.$props,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }